import React from 'react';
import memoizeOne from 'memoize-one';
import S from '../../styles/components';
import ListGroup from './ListGroup';
import ListItem from './ListItem';
import ListSection from './ListSection';
import ListContext from './ListContext';
import ListNode from './ListNode';

class List extends React.PureComponent {
  getContextState = memoizeOne((selections, onChange) => ({
    onChange,
    selections,
  }));

  render() {
    const {children, selections, onChange} = this.props;

    const contextState = this.getContextState(selections, onChange);

    return (
      <ListContext.Provider value={contextState}>
        <S.List>
          {children}
        </S.List>
      </ListContext.Provider>
    );
  }
}

List.Item = ListItem;
List.Group = ListGroup;
List.Section = ListSection;
List.Node = ListNode;

export default List;
